"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = (0, _styledComponents["default"])("svg").withConfig({
  displayName: "ColoredCaution___StyledSvg",
  componentId: "ss4eht-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function SvgColoredCaution(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return /*#__PURE__*/_react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "data-pka-anchor": "icon",
    focusable: false
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? /*#__PURE__*/_react["default"].createElement("title", null, title) : null, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#E5A823",
    fillRule: "nonzero",
    d: "M11.995 19.261c-.69 0-1.25-.562-1.25-1.254s.56-1.254 1.25-1.254 1.25.562 1.25 1.254-.56 1.254-1.25 1.254zm-1-9.28h2v6.02h-2V9.98zm10.89 10.587L12.89 2.51c-.34-.68-1.45-.68-1.79 0L2.105 20.568A1.001 1.001 0 003 22.02h17.99a1.001 1.001 0 00.895-1.452z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    stroke: "#916911",
    strokeWidth: 1.14,
    d: "M21.965 20.568L12.933 2.51c-.34-.68-1.456-.68-1.796 0L2.105 20.568a1.006 1.006 0 00.898 1.452h18.063a1.006 1.006 0 00.898-1.452z"
  })));
}

var _default = SvgColoredCaution;
exports["default"] = _default;
//# sourceMappingURL=ColoredCaution.js.map